import {
    WatchCriterialListToExcelSaga,
    watchACC1CSVListFetch,
    watchACC1ListFetch,
    watchAccoutingJobListDeleteSelected,
    watchAccoutingJobListExportSelected,
    watchAuthAutoLoginSubmit,
    watchAuthLoginFormSubmit,
    watchAuthLogoutFormSubmit,
    watchAuthPassRecoveryFormSubmit,
    watchAuthPassResetFormSubmit,
    watchBugReportPostSaga,
    watchCriteriaItemDeletionSaga,
    watchCriteriaItemRegistrationSaga,
    watchCriteriaItemUpdateSaga,
    watchFavorittListeDeletionSaga,
    watchFavorittListeGetReportSaga,
    watchFavorittListeListGetSaga,
    watchFavorittListeUpdateSaga,
    watchFetchMenuItems,
    watchGetAdminFirmListSaga,
    watchGetDriftPost,
    watchGetGroupListSaga,
    watchGetNyheterPost,
    watchGetTransById,
    watchGetUserList,
    watchGetUserListExportToData,
    watchHelpGet,
    watchLogToApiSaga,
    watchPostFeedbackdata,
    watchPostFormData,
    watchPostToWebSocket,
    watchPostUploadExcelDocumentCriteria,
    watchResetPredefinedReduxTransactionStoreSaga,
    watchUserDataFetchSaga,
    watchUserDataUpdateSaga,
    watchUserListDeletionSaga,
    watchUserLogouFromTerminal,
    watchUserProfileDataGet,
    watchUserProfileUpdateData,
    watchUserRegistrationSaga,
    watchcriteriaItemListGetSaga
} from './________sagas________';
import {
    watchGetNN05EmployeeIdSaga, watchGetNN05EmployeeIdValidateSaga, watchGetNN05EmployeeListSaga,
    watchGetNN05LocationByPostalCodeSaga, watchPostNN05EmployeeDeleteSaga, watchPostNN05EmployeeInsertSaga, watchPostNN05EmployeeUpdateSaga
} from './________sagas________/indexNN05';
import { watchfetchTradingPartnersSaga } from './________sagas________/indexNO01';
import { watchfetchSALGSaga } from './________sagas________/indexNV01';
import { watchFetchProductMetricsSaga } from './________sagas________/indexNV02';
import { watchGetNV03ItemListSaga } from './________sagas________/indexNV03';
import { watchGetNV05ListSaga } from './________sagas________/indexNV05';
import { watchNO04 } from './________sagas________/indexNO04';
import { watchNO03 } from './________sagas________/indexNO03';
import { watchNV06Saga } from './________sagas________/indexNV06';
import { watchNV04SnapshotSaga } from './________sagas________/indexNV04';

/**
 * Registers all root saga watchers with the provided saga middleware.
 *
 * This function centralizes the registration of all saga watchers used throughout the application.
 * Each watcher listens for specific Redux actions and handles side effects such as API calls,
 * authentication, user management, accounting, menu fetching, support, and more.
 *
 * Author: fabrice.miras@vitecsoftware.com
 * Date: 2025-07-07
 * 
 * Usage:
 *   import { registerCommonSagas } from './registerSagas';
 *   registerCommonSagas(sagaMiddleware);
 *
 * @param {import('redux-saga').SagaMiddleware} sagaMiddleware - The saga middleware instance to run sagas on.
 *
 * The sagas are grouped by domain for clarity:
 *   - AUTH USER: Authentication and user session management
 *   - ACCOUNTING: Accounting-related operations
 *   - Menu: Application menu and navigation
 *   - Heirloom: Legacy or special-case features
 *   - Profile: User profile management
 *   - Support: Feedback and support features
 *   - Utils: Utility and notification features
 *   - User Admin: User administration and management
 *   - Tallenes Tale: Reporting and statistics
 *   - NV03, NV01, NV01SALG, NN05: Domain-specific features
 */
export function registerCommonSagas(sagaMiddleware) {
    // AUTH USER
    sagaMiddleware.run(watchAuthLoginFormSubmit);
    sagaMiddleware.run(watchAuthAutoLoginSubmit);
    sagaMiddleware.run(watchAuthLogoutFormSubmit);
    sagaMiddleware.run(watchAuthPassRecoveryFormSubmit);
    sagaMiddleware.run(watchAuthPassResetFormSubmit);

    // ACCOUNTING
    sagaMiddleware.run(watchACC1ListFetch);
    sagaMiddleware.run(watchAccoutingJobListDeleteSelected);
    sagaMiddleware.run(watchAccoutingJobListExportSelected);
    sagaMiddleware.run(watchACC1CSVListFetch);

    // Menu
    sagaMiddleware.run(watchFetchMenuItems);

    // Heirloom
    sagaMiddleware.run(watchGetTransById);
    sagaMiddleware.run(watchHelpGet);
    sagaMiddleware.run(watchPostFormData);

    // Profile
    sagaMiddleware.run(watchUserProfileDataGet);
    sagaMiddleware.run(watchUserProfileUpdateData);

    // Support
    sagaMiddleware.run(watchPostFeedbackdata);

    // Utils
    sagaMiddleware.run(watchGetNyheterPost);
    sagaMiddleware.run(watchGetDriftPost);
    sagaMiddleware.run(watchLogToApiSaga);

    // User Admin 
    sagaMiddleware.run(watchGetUserList);
    sagaMiddleware.run(watchGetUserListExportToData);
    sagaMiddleware.run(watchUserDataFetchSaga);
    sagaMiddleware.run(watchUserDataUpdateSaga);
    sagaMiddleware.run(watchUserRegistrationSaga);
    sagaMiddleware.run(watchUserListDeletionSaga);
    sagaMiddleware.run(watchGetGroupListSaga);
    sagaMiddleware.run(watchPostToWebSocket);
    sagaMiddleware.run(watchGetAdminFirmListSaga);
    sagaMiddleware.run(watchUserLogouFromTerminal);

    // Tallenes Tale
    sagaMiddleware.run(watchcriteriaItemListGetSaga);
    sagaMiddleware.run(watchCriteriaItemUpdateSaga);
    sagaMiddleware.run(watchCriteriaItemRegistrationSaga);
    sagaMiddleware.run(watchCriteriaItemDeletionSaga);
    sagaMiddleware.run(WatchCriterialListToExcelSaga);
    sagaMiddleware.run(watchFavorittListeListGetSaga);
    sagaMiddleware.run(watchFavorittListeUpdateSaga);
    sagaMiddleware.run(watchFavorittListeDeletionSaga);
    sagaMiddleware.run(watchFavorittListeGetReportSaga);
    sagaMiddleware.run(watchPostUploadExcelDocumentCriteria);
    sagaMiddleware.run(watchBugReportPostSaga);

    // NV03
    sagaMiddleware.run(watchGetNV03ItemListSaga);

    // NV01
    sagaMiddleware.run(watchfetchTradingPartnersSaga);
    sagaMiddleware.run(watchFetchProductMetricsSaga);

    // NV01SALG
    sagaMiddleware.run(watchfetchSALGSaga);

    // Reset selected store branch
    sagaMiddleware.run(watchResetPredefinedReduxTransactionStoreSaga);

    // NN05
    sagaMiddleware.run(watchGetNN05EmployeeListSaga);
    sagaMiddleware.run(watchPostNN05EmployeeInsertSaga);
    sagaMiddleware.run(watchPostNN05EmployeeUpdateSaga);
    sagaMiddleware.run(watchPostNN05EmployeeDeleteSaga);
    sagaMiddleware.run(watchGetNN05EmployeeIdSaga);
    sagaMiddleware.run(watchGetNN05EmployeeIdValidateSaga);
    sagaMiddleware.run(watchGetNN05LocationByPostalCodeSaga);

    // NV05
    sagaMiddleware.run(watchGetNV05ListSaga);

    // NV04
    sagaMiddleware.run(watchNV04SnapshotSaga);

    // NO03 - Fakturakopi
    sagaMiddleware.run(watchNO03);

    // NV06 - Alfakodeoversikt
    sagaMiddleware.run(watchNV06Saga);

    // NO04 - OrdreSearch
    sagaMiddleware.run(watchNO04);
}
